import Spinner from 'react-bootstrap/Spinner';
import "./AppLoader.css"
function AppLoader() {
  return <Spinner animation="grow" size='lg' variant="primary" className='apploader' />;
}

export default AppLoader;